import type { MeResponse } from '@rw/shared';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  user: MeResponse | null;
  setSession: (token: string, user: MeResponse) => void;
  setUser: (user: MeResponse) => void;
  clear: () => void;
}

/** Token + user are persisted so the app shell works offline after a reload. */
export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      clear: () => set({ token: null, user: null }),
    }),
    { name: 'rw:auth', storage: createJSONStorage(() => localStorage) },
  ),
);
